module.exports = __webpack_public_path__ + "3-56.jpg?d503fb579ee04ed501de6819c799f018";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-56.jpg
// module id = 138
// module chunks = 0